/*
 * Public API Surface of ngx-quill/config
 */

export * from './quill-defaults'
export * from './quill-config.module'
export * from './quill-editor.interfaces'
export * from './provide-quill-config'
